import { FULL_MONTHS } from 'helpers/dateHelper';
import { SPLIT_BY } from 'routes/BudgetModule/config/constants';
import { DateString } from '../business/types';

const monthFormatter = (value: string): string => {
    const month = new Date(value).getMonth();
    return FULL_MONTHS[month];
};

export function getPivotedField<TPrefix extends string, TSuffix extends string>(
    prefix: TPrefix,
    suffix: TSuffix,
): PivotedField<TPrefix, TSuffix> {
    return `${prefix}${SPLIT_BY}${suffix}`;
}

export const getDateColumnLabel = (
    dateStr: DateString,
    isMonthly: boolean,
): string => {
    const formattedDate = `${dateStr.substring(0, 4)}-${dateStr.substring(
        4,
        6,
    )}-${dateStr.substring(6, 8)}`;
    const year = new Date(formattedDate).getFullYear().toString();
    return isMonthly ? `${monthFormatter(formattedDate)} ${year}` : year;
};

export const checkIsEtablissementsFilterActiveConsistencyWithSelectedEtablissements =
    (
        isEtablissementsFilterActive: boolean,
        selectedEtablissementSoftwareIds: string[],
    ): boolean => {
        return isEtablissementsFilterActive &&
            selectedEtablissementSoftwareIds.length === 0
            ? false
            : isEtablissementsFilterActive;
    };
export const checkIsPayBudgetsFilterActiveConsistencyWithSelectedPayBudgets = (
    isPayBudgetFilterActive: boolean,
    selectedPayBudgetSoftwareIds: string[],
): boolean => {
    return isPayBudgetFilterActive && selectedPayBudgetSoftwareIds.length === 0
        ? false
        : isPayBudgetFilterActive;
};
